import React from "react";
import { MessageCircle } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { waLink } from "@/lib/api";

export default function FloatingWhatsApp() {
  const { site } = useSite();
  const href = waLink(site.whatsapp, "Hello PTG, I would like to inquire about admission for Std ___.");

  return (
    <a href={href} target="_blank" rel="noreferrer"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2 rounded-full bg-emerald-500 p-4 text-white shadow-2xl hover:bg-emerald-600 hover:scale-110 active:scale-95 transition-all duration-300 group"
      data-testid="floating-whatsapp" aria-label="Chat with PTG on WhatsApp">
      <MessageCircle className="h-6 w-6" />
      <span className="hidden sm:inline max-w-0 overflow-hidden whitespace-nowrap group-hover:max-w-[140px] transition-all duration-300 font-semibold text-sm">Chat with us</span>
    </a>
  );
}
